module.exports = __webpack_public_path__ + "static/media/3@2x.d73152ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity_100/3@2x.png
// module id = 374
// module chunks = 0